import { Transforms } from 'slate'
import { dispatch, listen } from './utils'
import { useEffect } from 'react'
import LocalStorage from './localStorage'

export const setShowProperties = (editor, isShow) => {
  editor['showProperties'] = isShow
  const savedSelection = editor.selection
  Transforms.select(editor, [0])
  setTimeout(() => {
    if (!savedSelection) {
      return Transforms.deselect(editor)
    }
    Transforms.setSelection(editor, savedSelection)
  })
}

function useShowProperties({ editor, isPlugin, key = 'key' }) {
  const apiKey = editor?.requestProps?.apiKey
  const userId = editor?.requestProps?.currentUser?.uid
  const localStorageKey = `${key}-${apiKey}-${userId}`

  useEffect(() => {
    if (!apiKey || !userId) return
    LocalStorage.getItem(isPlugin,localStorageKey)
      .then((isShow) => {
        setShowProperties(editor, isShow === 'YES')
      })
      .catch(console.error)

    listen(
      localStorageKey,
      (isShow) => {
        setShowProperties(editor, isShow)
      },
      isPlugin
    )
  }, [apiKey, userId])

  editor.dispatchShowProperties = (isShow) => {
    if (!apiKey || !userId) return
    LocalStorage.setItem(isPlugin,localStorageKey, isShow === true ? 'YES' : 'NO').catch(console.error)
    dispatch(localStorageKey, isShow, isPlugin)
  }
}

export default useShowProperties